import {createCommand, LexicalCommand} from 'lexical';
import {LinkAttributes} from '@lexical/link';
import {InsertTableCommandPayload} from './plugins/TablePlugin/types';


export const SET_TEXT_COLOR: LexicalCommand<Record<'color', string> | void> = createCommand();

export const INSERT_COMMENT: LexicalCommand<void> = createCommand();

export const INSERT_TAB_SPACES: LexicalCommand<void> = createCommand();

export type EditLinkPayload = {
    url: string;
    text?: string;
    update?: boolean;
} & LinkAttributes;

export const ADD_LINK_COMMAND: LexicalCommand<EditLinkPayload | null> = createCommand();

export const OPEN_LINK_MODAL_COMMAND: LexicalCommand<null> = createCommand();

export const INSERT_TABLE_COMMAND: LexicalCommand<InsertTableCommandPayload> = createCommand();

export const INSERT_DIVIDER: LexicalCommand<void> = createCommand();
